import React, { useState } from "react";
import ResumeCard from "./ResumeCard";
import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import ReactInputMask from "react-input-mask";
import Storage from "@/app/core/util/Storage";
import { Typeahead } from "react-bootstrap-typeahead";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import BoxItem from "@/app/core/layouts/main-components/delivery/BoxItem";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { CurrencyOption, MoneyMask, ProcessValue } from "@/app/core/util/helpers/MoneyHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { toast } from "react-toastify";
import ConfirmationModal from "@/app/core/layouts/main-components/delivery/ConfirmationModal";
import { UserTypeObj } from "@/app/core/util/helpers/UserHelper";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";

export default function ConfirmationStep({ infos, back, reportItens, nationalCarrier, internationalCarrier, reportResponsibles, responsibles, end }) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [query, setQuery] = useState("");
    const [collect, setCollect] = useState({ personType: UserTypeObj.Person });
    const [delivery, setDelivery] = useState({ personType: UserTypeObj.Person });
    const [users, setUsers] = useState([]);
    const [pricing, setPricing] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const date = new Date();
    const [change, setChange] = useState(date.getTime());
    useEffect(() => {
        setData(infos);
        if (userData && userData.companyId) {
            loadCompanyUsers()
        }
        console.log("Alguma coisa mudou", infos, nationalCarrier, internationalCarrier)
    }, [infos, nationalCarrier, internationalCarrier])

    useEffect(() => {
        if (responsibles.collect != undefined) {
            setCollect(responsibles.collect);
            setDelivery(responsibles.delivery);
        }
    }, [])

    function notifyChange() {
        setChange(date.getTime());
    }

    function loadCompanyUsers() {
        AccountController.CompanyUsers(userData.companyId, res => setUsers(res));
    }

    function handleCollectChange(evt) {
        setCollect(OnDataChange(collect, evt));
    }

    function handleDeliveryChange(evt) {
        setDelivery(OnDataChange(delivery, evt));
    }

    function goBack() {
        reportItens(data)
        back()
    }

    function confirmDelivery() {
        if (data.collectionDate != "" && data.collectionDate != undefined && data.collectionDate != "0001-01-01T00:00:00") {
            console.log("Erro", data.collectionDate);

            if (data.initial_time == undefined || data.initial_time == "") {
                toast.error(Translate(Message.PendingInitialTime));
                return;
            }
            if (data.final_time == undefined || data.final_time == "") {
                toast.error(Translate(Message.PendingFinalTime));
                return;
            }
            if (data.instruction == undefined || data.instruction == "") {
                toast.error(Translate(Message.PendingData));
                return;
            }
        }

        if (!collect.responsibleName || !collect.email || !collect.phone) {
            toast.error(Translate(Message.MissingSender));
        } else if (!delivery.responsibleName || !delivery.email || !delivery.phone) {
            toast.error(Translate(Message.MissingReceiver));
        } else {
            reportResponsibles({ collect, delivery })
            if (window.confirm(Translate(Message.Confirm))) {
                setData({
                    ...data,
                    origin: { ...data.origin, ...collect },
                    destination: { ...data.destination, ...delivery }
                })
                setShowModal(true)
            }
        }
    }

    function handleItens() { }
    function removeBox() { }

    function endProcess() {
        setShowModal(false);
        end()
    }

    function handleDataChange(evt, type) {
        let newData = OnDataChange(data, evt, type);
        setData(newData);
        reportItens(newData);
    }

    return (
        <div className="col-12">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="text-muted">{Translate(Message.ConfirmRequest)}</h3>
                </div>
                <div className="col-md-8">
                    <h4 className="text-muted">{Translate(Message.RegisterResponsible)}</h4>

                    <div className="block block-rounded block-bordered border-info">
                        <div className="block-header">
                            <div className="block-title">Responsável pela coleta</div>
                            <div className="block-tools">
                                {userData && userData.companyId ?
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light">
                                            <i className="fa fa-search" /> Procurar usuário
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Typeahead
                                                options={users}
                                                labelKey={(option) => `${option.firstName} ${option.lastName} - ${option.email}`}
                                                onSearch={(q) => setQuery(q)}
                                                name="country_code"
                                                placeholder="Selecionar"
                                                id={`coleta-responsavel`}
                                                onChange={(selected) => {
                                                    if (selected[0] !== undefined || selected !== null) {
                                                        setCollect({
                                                            name: `${selected[0].firstName} ${selected[0].lastName}`,
                                                            email: selected[0].email,
                                                        });
                                                    }
                                                }} />
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    : ""}
                                <div class="form-group">
                                    <label class="d-block">Tipo de remetente</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" class="custom-control-input" id="example-rd-custom-inline1"
                                            name="personType"
                                            checked={collect && collect.personType == UserTypeObj.Person ? true : false}
                                            onChange={evt => setCollect({ ...collect, personType: UserTypeObj.Person })}
                                        />
                                        <label class="custom-control-label" for="example-rd-custom-inline1">{Translate(Message.PhysicalPerson)}</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" class="custom-control-input" id="example-rd-custom-inline2"
                                            name="personType"
                                            checked={collect && collect.personType == UserTypeObj.LegalPerson ? true : false}
                                            onChange={evt => setCollect({ ...collect, personType: UserTypeObj.LegalPerson })}
                                        />
                                        <label class="custom-control-label" for="example-rd-custom-inline2">{Translate(Message.LegalPerson)}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="block-content row">
                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.Name)}</span>
                                <input type="text" className="form-control" value={collect && collect.responsibleName} name="responsibleName" onChange={evt => handleCollectChange(evt)} />
                            </div>
                            <div className="form-group col-md-6">
                                <span>*Email</span>
                                <input type="email" className="form-control" value={collect && collect.email} name="email" onChange={evt => handleCollectChange(evt)} />
                            </div>
                            <div className="form-group col-md-6 ">
                                <span>*{Translate(Message.Phone)}</span>
                                <ReactInputMask
                                    mask="99999-9999"
                                    maskChar=""
                                    type="text"
                                    className="form-control"
                                    id="advanced-filter-document"
                                    name="phone"
                                    value={collect && collect.phone}
                                    placeholder="99999-9999"
                                    onChange={(event) => {
                                        handleCollectChange({
                                            target: {
                                                name: "phone",
                                                value: event.target.value.replace(/\D/g, ""),
                                            },
                                        });
                                    }}
                                />
                            </div>

                            {collect && collect.personType == UserTypeObj.Person ?
                                <div className="form-group col-md-6">
                                    <span>*{Translate(Message.Id)}</span>
                                    <ReactInputMask
                                        mask="999.999.999-99"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="document"
                                        value={collect && collect.document}
                                        placeholder="999.999.999-99"
                                        onChange={(event) => {
                                            handleCollectChange({
                                                target: {
                                                    name: "document",
                                                    value: event.target.value.replace("/\D/g", ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                :
                                <div className="form-group col-md-6">
                                    <span>*CNPJ</span>
                                    <ReactInputMask
                                        mask="99.999.999/9999-99"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="document"
                                        value={collect && collect.document}
                                        placeholder="99.999.999/9999-99"
                                        onChange={(event) => {
                                            handleCollectChange({
                                                target: {
                                                    name: "document",
                                                    value: event.target.value.replace("/\D/g", ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                            }
                            {collect && collect.personType == UserTypeObj.Person ?
                                <div className="form-group col-md-12">
                                    <span>*RG</span>
                                    <ReactInputMask
                                        mask="99.999.999-9"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="stateTaxId"
                                        value={collect && collect.stateTaxId}
                                        placeholder=""
                                        onChange={(event) => {
                                            handleCollectChange({
                                                target: {
                                                    name: "stateTaxId",
                                                    value: event.target.value.replace(/\D/g, ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                :
                                <div className="form-group col-md-12">
                                    <span>*Inscrição estadual</span>
                                    <input
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="stateTaxId"
                                        value={collect && collect.stateTaxId}
                                        placeholder=""
                                        onChange={(event) => handleCollectChange(event)}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className="block block-rounded block-bordered border-info">
                        <div className="block-header">
                            <div className="block-title">Responsável pela Entrega</div>
                            <div className="block-tools">
                                {userData && userData.companyId ?
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light">
                                            <i className="fa fa-search" /> Procurar usuário
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Typeahead
                                                options={users}
                                                labelKey={(option) => `${option.firstName} ${option.lastName} - ${option.email}`}
                                                onSearch={(q) => setQuery(q)}
                                                name="country_code"
                                                placeholder="Selecionar"
                                                id={`coleta-responsavel`}
                                                onChange={(selected) => {
                                                    if (selected[0] !== undefined || selected !== null) {
                                                        setDelivery({
                                                            name: `${selected[0].firstName} ${selected[0].lastName}`,
                                                            email: selected[0].email,
                                                        });
                                                    }
                                                }} />
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    : ""}
                                <div class="form-group">
                                    <label class="d-block">Tipo de destinatário</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" class="custom-control-input" id="personTypeDelivery1"
                                            name="personTypeDelivery"
                                            checked={delivery && delivery.personType == UserTypeObj.Person ? true : false}
                                            onChange={evt => setDelivery({ ...delivery, personType: UserTypeObj.Person })}
                                        />
                                        <label class="custom-control-label" for="personTypeDelivery1">{Translate(Message.PhysicalPerson)}</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" class="custom-control-input" id="personTypeDelivery2"
                                            name="personTypeDelivery"
                                            checked={delivery && delivery.personType == UserTypeObj.LegalPerson ? true : false}
                                            onChange={evt => setDelivery({ ...delivery, personType: UserTypeObj.LegalPerson })}
                                        />
                                        <label class="custom-control-label" for="personTypeDelivery2">{Translate(Message.LegalPerson)}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="block-content row">
                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.Name)}</span>
                                <input type="text" className="form-control" value={delivery && delivery.responsibleName} name="responsibleName" onChange={evt => handleDeliveryChange(evt)} />
                            </div>
                            <div className="form-group col-md-6">
                                <span>*Email</span>
                                <input type="email" className="form-control" value={delivery && delivery.email} name="email" onChange={evt => handleDeliveryChange(evt)} />
                            </div>
                            <div className="form-group col-md-6">
                                <span>*{Translate(Message.Phone)}</span>
                                <ReactInputMask
                                    mask="99999-9999"
                                    maskChar=""
                                    type="text"
                                    className="form-control"
                                    id="advanced-filter-document"
                                    name="phone"
                                    value={delivery && delivery.phone}
                                    placeholder="99999-9999"
                                    onChange={(event) => {
                                        handleDeliveryChange({
                                            target: {
                                                name: "phone",
                                                value: event.target.value.replace(/\D/g, ""),
                                            },
                                        });
                                    }}
                                />
                            </div>

                            {delivery && delivery.personType == UserTypeObj.Person ?
                                <div className="form-group col-md-6">
                                    <span>*{Translate(Message.Id)}</span>
                                    <ReactInputMask
                                        mask="999.999.999-99"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="document"
                                        value={delivery && delivery.document}
                                        placeholder="999.999.999-99"
                                        onChange={(event) => {
                                            handleDeliveryChange({
                                                target: {
                                                    name: "document",
                                                    value: event.target.value.replace("/\D/g", ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                :
                                <div className="form-group col-md-6">
                                    <span>*CNPJ</span>
                                    <ReactInputMask
                                        mask="99.999.999/9999-99"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="document"
                                        value={delivery && delivery.document}
                                        placeholder="99.999.999/9999-99"
                                        onChange={(event) => {
                                            handleDeliveryChange({
                                                target: {
                                                    name: "document",
                                                    value: event.target.value.replace("/\D/g", ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                            }
                            {delivery && delivery.personType == UserTypeObj.Person ?
                                <div className="form-group col-md-12">
                                    <span>*RG</span>
                                    <ReactInputMask
                                        mask="99.999.999-9"
                                        maskChar=""
                                        type="text"
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="stateTaxId"
                                        value={delivery && delivery.stateTaxId}
                                        placeholder=""
                                        onChange={(event) => {
                                            handleDeliveryChange({
                                                target: {
                                                    name: "stateTaxId",
                                                    value: event.target.value.replace(/\D/g, ""),
                                                },
                                            });
                                        }}
                                    />
                                </div>
                                :
                                <div className="form-group col-md-12">
                                    <span>*Inscrição estadual</span>
                                    <input
                                        className="form-control"
                                        id="advanced-filter-document"
                                        name="stateTaxId"
                                        value={delivery && delivery.stateTaxId}
                                        placeholder=""
                                        onChange={(event) => handleDeliveryChange(event)}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    {userData && userData.type == UserTypeObj.LegalPerson ?
                        <div className="block block-rounded block-bordered border-info">
                            <div className="block-header">
                                <div className="block-title">{Translate(Message.Invoice)} (Opcional)
                                </div>
                            </div>
                            <div className="block-content">
                                <div className="form-group">
                                    <span></span>
                                    <input type="text" className="form-control" name="nfkey" value={data && data.nfkey} onChange={evt => handleDataChange(evt)} />
                                </div>
                            </div>
                        </div>
                        : ""}
                    {/* {userData && userData.type == UserTypeObj.LegalPerson ? */}
                    {/* {internationalCarrier && internationalCarrier.quotationId ?
                        <div className="block block-rounded block-bordered border-info">
                            <div className="block-header">
                                <div className="block-title">{Translate(Message.CollectionInstructions)}
                                </div>
                            </div>
                            <div className="block-content">
                                <div className="form-group">
                                    <span>{Translate(Message.CollectionDate)}</span>
                                    <input type="date" className="form-control" name="collectionDate" value={data && data.collectionDate} onChange={evt => handleDataChange(evt, FieldTypeObj.Date)} />
                                </div>
                                <div className="form-group">
                                    <span>{Translate(Message.CollectionInitialTime)}</span>
                                    <input type="time" className="form-control" name="initial_time" value={data && data.initial_time} onChange={evt => handleDataChange(evt)} />
                                </div>
                                <div className="form-group">
                                    <span>{Translate(Message.CollectionFinalTime)}</span>
                                    <input type="time" className="form-control" name="final_time" value={data && data.final_time} onChange={evt => handleDataChange(evt)} />
                                </div>
                                <div className="form-group">
                                    <span>{Translate(Message.CollectionInstructions)}</span>
                                    <textarea className="form-control" name="instruction" value={data && data.instruction} onChange={evt => handleDataChange(evt)} />
                                </div>
                            </div>
                        </div>
                        : ""} */}
                    {/* : ""} */}
                    <h4 className="text-muted">{Translate(Message.Package)}</h4>

                    <div className="block block-rounded block-bordered border-info">
                        <div className="block-content">
                            {data && data.boxes && data.boxes.map((item, index) => (
                                <BoxItem data={item} report={itens => handleItens(itens, index)} presentation={true} delivery={data} removeBox={() => removeBox(index)} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    {internationalCarrier && internationalCarrier.quotationId ?
                        <CurrencyOption report={() => notifyChange()} />
                        : ""}
                    <ResumeCard data={infos} pricing={pricing} />
                    <div className="block block-rounded block-bordered">
                        <div className="block-header">
                            <div className="block-title"> <i className="far fa-money-bill-alt text-success mr-2"></i>{Translate(Message.Details)}</div>
                        </div>
                        <div className="ml-1 mr-1 mb-1 mt-1">
                            <table className="table table-hover">
                                {internationalCarrier && internationalCarrier.quotationId ?
                                    <tbody>
                                        <tr>
                                            <td>{Translate(Message.Services)}</td>
                                            <td>{internationalCarrier.name}</td>
                                        </tr>
                                        <tr>
                                            <td>{Translate(Message.Term)}</td>
                                            <td>{internationalCarrier.transit_days}</td>
                                        </tr>
                                        <tr>
                                            <td>{Translate(Message.Freight)}</td>
                                            <td>{change && ProcessValue(internationalCarrier.freight_final)}</td>
                                        </tr>
                                        <tr>
                                            <td>{Translate(Message.Insurance)}</td>
                                            <td>{change && ProcessValue(internationalCarrier.insurance_final)}</td>
                                        </tr>
                                        <tr>
                                            <td>{Translate(Message.Taxes)}</td>
                                            <td>{change && ProcessValue(internationalCarrier.tax_final)}</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>{change && ProcessValue(internationalCarrier.currency_payment_amount)}</td>
                                        </tr>
                                    </tbody>
                                    : ""}
                                {nationalCarrier && nationalCarrier.serviceValue ?
                                    <tbody>
                                        <tr>
                                            <td>{Translate(Message.Services)}</td>
                                            <td>{nationalCarrier.name}</td>
                                        </tr>
                                        <tr>
                                            <td>{Translate(Message.Term)}</td>
                                            <td>{nationalCarrier.deadline}</td>
                                        </tr>
                                        {nationalCarrier.insurance != undefined ? <tr>
                                            <td>{Translate(Message.Insurance)}</td>
                                            <td>R${MoneyMask(nationalCarrier.insurance, 2)}</td>
                                        </tr> : ""}
                                        <tr>
                                            <td>{Translate(Message.Freight)}</td>
                                            <td>R${MoneyMask(nationalCarrier.freight, 2)}</td>
                                        </tr>
                                        <tr>
                                            <td>{Translate(Message.Taxes)}</td>
                                            <td>R${MoneyMask(nationalCarrier.taxCost, 2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td>R${MoneyMask(nationalCarrier.totalPrice, 2)}</td>
                                        </tr>
                                    </tbody>
                                    : ""}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12 text-center">
                <button type="button" className="btn btn-hero-lg btn-hero-white" onClick={() => goBack()}>
                    <i className="fa fa-arrow-left mr-2"></i> {Translate(Message.GoBack)}
                </button>
                <button type="button" className="btn btn-hero-lg btn-hero-success" onClick={() => confirmDelivery()}>
                    {Translate(Message.Advance)} <i className="si si-check ml-2"></i>
                </button>
            </div>
            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                delivery={data && data}
                nationalCarrier={nationalCarrier}
                internationalCarrier={internationalCarrier}
                collectResponsible={collect}
                deliveryResponsible={delivery}
                endPayment={() => endProcess()} />
        </div>
    )
}